/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyOTPChallengeRequest
 */
export interface VerifyOTPChallengeRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyOTPChallengeRequest
     */
    challenge_id: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyOTPChallengeRequest
     */
    code: string;
}

/**
 * Check if a given object implements the VerifyOTPChallengeRequest interface.
 */
export function instanceOfVerifyOTPChallengeRequest(value: object): value is VerifyOTPChallengeRequest {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function VerifyOTPChallengeRequestFromJSON(json: any): VerifyOTPChallengeRequest {
    return VerifyOTPChallengeRequestFromJSONTyped(json, false);
}

export function VerifyOTPChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyOTPChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'code': json['code'],
    };
}

export function VerifyOTPChallengeRequestToJSON(json: any): VerifyOTPChallengeRequest {
    return VerifyOTPChallengeRequestToJSONTyped(json, false);
}

export function VerifyOTPChallengeRequestToJSONTyped(value?: VerifyOTPChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'code': value['code'],
    };
}

